export default function P1() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="256"
      height="464"
      fillRule="evenodd"
      clipRule="evenodd"
      imageRendering="optimizeQuality"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
      version="1.1"
      viewBox="0 0 256 464"
      xmlSpace="preserve"
    >
      <defs>
        <clipPath clipRule="nonzero">
          <path d="M1515 6513H223V5277h533v429c0 74 60 134 134 134h625z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3334 6513h-722v-673h722z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M2612 6513H1515v-673h83v673z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M2612 6513H1598v-673h1014z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M4626 6513H3334h625v-676c8 2 18 3 27 3h640z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3959 6513h-56v-701c16 13 35 21 56 26v676z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3904 6513h-570v-673h10c103 0 88-65 88-188v-375h420v429c0 43 20 81 52 106z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M3344 5840h-10v-563h98v375c0 123 15 188-88 188z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M6445 6513h-722v-673h722z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M5723 6513H4626v-673h83v673z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M5723 6513H4709v-673h1014z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7820 5277h2305v1236h56V5277h-56z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7737 6513H6446h624V5277h750-84v1236z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7070 6513h-56V5277h56z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M7015 6513h-570v-673c72-3 129-62 129-134v-429h441z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M6445 5840v-563h129v429c0 72-57 131-129 134z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M10126 6513H8834V5277h1292z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M8834 6513H7737V5277h83v1236z"></path>
        </clipPath>
        <clipPath clipRule="nonzero">
          <path d="M8834 6513H7820V5277h1014z"></path>
        </clipPath>
      </defs>
      <g display="inline">
        <path
          fillRule="evenodd"
          d="M2685 4226L2573 4035 2471 4109 2589 4293z"
          className="p1-fil9"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -73 -95.969)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M174.384 313.938l-11.136 17.183c-.672 1.152-.48 2.688.48 3.648l27.648-17.663-7.392-9.408z"
          className="p1-fil0"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M150.097 203.061l5.184 40.223 32.543 55.966-26.976 14.496-26.303-52.318c-1.92-3.264-3.264-6.72-4.224-10.368l-6.047-23.903 25.823-24.192z"
          className="p1-fil10"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M132.53 257.492l-.193-.672.288.576v.096zm-2.017-5.856l-6.815-19.776 1.536-.863 5.183 20.159c0 .192.096.384.096.576z"
          className="p1-fil11"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M132.53 257.396l-.289-.576-1.824-5.184c-.096-.192-.096-.384-.096-.576l-5.183-20.16 24.67-14.687-17.375 41.183z"
          className="p1-fil12"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          d="M1925 4446L1969 4212 1844 4219 1808 4451z"
          className="p1-fil9"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
          transform="matrix(.096 0 0 .096 -73 -95.969)"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M100.85 328.817l-18.623 8.544c-1.248.576-1.824 2.016-1.536 3.264h32.735l-1.248-11.904-11.424.096z"
          className="p1-fil0"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M145.969 191.926l-28.895-6.624c0 6.24-12.192 47.71-16.8 59.998a50.943 50.943 0 00-2.783 11.424l-5.952 65.662 30.815.384 4.704-64.03 15.071-33.695c10.464-19.296 3.84-33.023 3.84-33.023z"
          className="p1-fil10"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M122.834 132.984l19.871-.384s.576-24.864-13.055-25.248c-11.904-.288-13.152 15.456-13.152 15.456l6.432 10.176z"
          className="p1-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M130.993 109.56c.768.288 1.44.672 2.112 1.152 5.856 4.608 3.552 14.976-.864 19.968-2.4 2.784-6.143 4.32-9.695 3.36-5.184-1.344-7.296-6.816-6.72-11.904.384-3.84 2.112-7.488 4.896-10.08 2.784-2.496 6.816-3.84 10.271-2.592z"
          className="p1-fil14"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M133.681 127.512c1.056.864 2.688 1.056 3.936.48 1.248-.576 2.112-1.824 2.304-3.264.192-1.248-.288-2.592-1.248-3.264-.96-.672-2.592-.48-3.264.576l-1.632 5.472z"
          className="p1-fil14"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M134.737 124.056l.864 17.76a6.22 6.22 0 01-5.472 6.527c-3.743.48-7.007-2.496-6.911-6.336l.288-16.607z"
          className="p1-fil14"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M123.218 136.632v-2.4s4.992.96 8.927-3.552c0 0-2.016 4.896-8.927 5.952z"
          className="p1-fil15"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M136.081 125.592c.384 0 .768-.096 1.152-.384.288-.192.48-.576.48-.96 0-.576-.48-1.056-.96-1.248-.096 0-.288 0-.384.192 0 .096 0 .288.192.384.384.096.672.384.672.672a.528.528 0 01-.288.48c-.192.192-.48.288-.768.288-.192 0-.288.096-.288.288 0 .192.096.288.288.288z"
          className="p1-fil15"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M125.042 124.824c.096.576.864.96 1.824.864.96-.096 1.632-.672 1.536-1.344-.096-.576-.864-.96-1.824-.864-.96.096-1.632.672-1.536 1.344z"
          className="p1-fil16"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M120.626 125.592l-1.056-.768-.192-.384.288-.096c.096 0 .288-.192.48-.384s.288-.384.48-.48l.864-1.152c-.192.48-.384.864-.576 1.344a5.5 5.5 0 01-.384.672c-.192.192-.288.384-.576.576l.096-.48.768 1.056v.096h-.096z"
          className="p1-fil15"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M119.474 127.224c.384.192.768.384 1.152.48.384.096.768 0 1.152-.096.384-.096.672-.384.96-.672l.864-.96c-.096.192-.192.384-.192.672-.096.192-.192.384-.384.576a3 3 0 01-1.056.864c-.48.192-.96.192-1.44 0s-.768-.48-1.056-.864z"
          className="p1-fil15"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M118.034 123.864c0 .576-.768 1.056-1.632 1.056-.192 0-.384 0-.576-.096a7.767 7.767 0 010-2.112c.192 0 .384-.096.576-.096.96 0 1.632.48 1.632 1.056z"
          className="p1-fil16"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M124.274 120.408c0 .576 0 1.152.096 1.632.096.576.48.864.864.768.48 0 .768-.48 1.056-.96.192-.48.384-1.056.48-1.632l.192-.096.096.192c0 .576-.192 1.152-.384 1.728-.288.576-.672 1.152-1.44 1.248-.384 0-.768-.096-1.056-.288-.288-.288-.384-.576-.384-.864-.096-.576-.096-1.248.096-1.824l.192-.096.096.192z"
          className="p1-fil15"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M117.074 119.928c0 .48 0 .96.096 1.344.096.48.288.768.672.672.288 0 .576-.384.768-.768.192-.384.288-.864.384-1.344l.192-.096.096.192c0 .48-.096.96-.288 1.44-.192.48-.48 1.056-1.152 1.152-.288 0-.672-.096-.864-.384-.192-.288-.288-.48-.288-.768-.096-.48 0-1.056.096-1.536l.192-.096z"
          className="p1-fil15"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M129.842 118.776s.48-8.16 4.991-7.392c0 0-1.728-3.648-6.623-3.84-3.648-.192-7.008 1.728-9.12 4.608-1.152 1.536-2.688 4.32-3.264 6.336 1.728 0 14.016.288 14.016.288z"
          className="p1-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M133.585 110.616s-3.456 1.44-1.824 7.584c1.728 6.144 5.376 2.304 5.376 2.304s1.152-9.984-3.552-9.888z"
          className="p1-fil13"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M90.867 135.384l-.96 4.991s-18.432 44.255-9.216 46.079c7.488 1.536 25.247-11.424 25.247-11.424l-6.432-10.943-10.463 7.583s5.952-25.439 7.104-28.03c0 0 3.935-2.017 4.511-3.745.192-.672.192-1.824-2.111.288-1.056.96-3.168-.288-2.208-1.92.96-1.631 3.551-1.727 4.415.48 0 0 .864.384 1.248-.288.384-.672-1.152-3.167-3.072-3.167-1.247 0-2.303.48-2.303.48s2.303-5.856 1.824-6.048c-.48-.192-1.248-.096-3.744 6.336 0 0 1.44-5.184 1.536-5.952.096-.672-.672-1.44-1.248.192-.096.192-2.016 5.184-2.016 5.184s.48-3.552.48-3.84c.096-.768-.672-.864-1.056 0-.288.672-1.44 3.648-1.44 3.648z"
          className="p1-fil14"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M151.249 165.815s.672-17.856-15.552-28.703c0 0-7.391 2.88-12.863 2.303-3.84 9.696-6.528 17.088-12.096 58.175 0 0 11.52-.48 18.912.096 10.943.768 21.887-3.936 21.887-3.936l-.288-27.84z"
          className="p1-fil17"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M122.834 139.415L99.41 162.743s1.824 15.263 5.952 16.895l17.088-8.928.384-31.199z"
          className="p1-fil17"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M104.402 195.67l-8.255 1.152c-1.344.192-2.688-.768-2.88-2.208l-2.4-17.184c-.192-1.344.768-2.688 2.112-2.88l8.255-1.152c1.344-.192 2.688.768 2.88 2.208l2.4 17.184c.192 1.344-.768 2.688-2.112 2.88z"
          className="p1-fil18"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M162.768 179.446l-39.55 1.152v39.935s-.864 6.72 8.447 6.432c9.216-.288 24.096-1.44 24.096-1.44s5.568-2.496 6.72-8.736c1.151-6.144.287-37.439.287-37.439z"
          className="p1-fil19"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M155.185 182.134s-5.376-44.638-19.104-43.487c-13.727 1.152-7.295 47.999-7.295 47.999l4.607.288s-8.351-47.999 4.032-47.71c12.384.287 14.016 47.998 14.016 47.998z"
          className="p1-fil19"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M134.833 186.934c-1.44-2.4-2.88-4.8-4.224-7.2-3.743 1.056-7.2 1.92-10.08 2.496-2.591.48-4.991.96-6.815 1.344l-1.728.288c-1.056.192-1.728.288-1.728.288s-5.664-.768-6.912-2.784c-.288.096-.672.576-.576 1.056.384 1.728 2.112 2.688 2.112 2.688s-8.255 1.728-7.871 2.4c.48.672 6.143-.192 6.143-.192s-7.871 1.824-7.2 2.4c.289.192.673.096 6.528-.192 0 0-5.567 1.824-4.607 2.016 1.247.384 5.087-.384 5.087-.384s-3.84 1.44-3.072 1.632c.768.192 11.328-2.112 11.328-2.112s24-3.072 23.711-3.744z"
          className="p1-fil14"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M159.793 167.063c-9.696 5.183-9.024 4.991-16.896 7.583 0 0-6.624-13.727-10.848-22.847-1.248-2.688-.672-5.856 1.344-7.968 3.264-3.456 8.64-2.496 11.328 1.536 3.936 6.048 15.168 21.696 15.168 21.696z"
          className="p1-fil17"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M143.857 174.358l-6.432-12.767c-.096-.192-.288-.192-.384-.096-.192.096-.192.288-.096.384l6.432 12.767c.096.192.288.192.384.096.192-.096.192-.288.096-.384z"
          className="p1-fil20"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
        <path
          fillRule="evenodd"
          strokeWidth="0.096"
          d="M159.313 167.35c-3.552 1.825-6.528 3.648-9.024 4.704v.096a117.894 117.894 0 01-19.776 7.68c.576 2.4 1.152 5.472 1.728 7.872 24.768-3.456 29.951-11.904 30.143-13.056.48-.864-.864-3.744-3.071-7.2z"
          className="p1-fil14"
          clipRule="evenodd"
          imageRendering="optimizeQuality"
          opacity="1"
          shapeRendering="geometricPrecision"
          textRendering="geometricPrecision"
        ></path>
      </g>
    </svg>
  );
}
